import type { ReactNode, MouseEvent, ButtonHTMLAttributes } from "react";
import { Button } from "@repo/ui";
import { cn } from "@repo/utils";

type ButtonSize = "sm" | "md";

type Props = {
  id: number;
  size?: ButtonSize;
  label: string;
  props?: ButtonHTMLAttributes<HTMLButtonElement>;
  children?: ReactNode;
  customDesignLogic?: string;
  customTextDesignLogic?: string;
  onRowItemClick: (id: number, e: MouseEvent<HTMLButtonElement>) => void;
};

export const RowButton = ({
  id,
  size = "md",
  label,
  children,
  customDesignLogic,
  customTextDesignLogic,
  onRowItemClick,
  props,
}: Props) => {
  const buttonSize: string =
    {
      sm: "px-3 py-5",
      md: "px-3 py-6.5",
    }[size as ButtonSize] || "md";

  return (
    <Button
      key={id}
      variant={null}
      onClick={(e) => onRowItemClick(id, e)}
      className={cn(
        `flex w-full cursor-pointer items-center gap-3 rounded-md border border-gray-200 bg-white ${buttonSize} transition-colors hover:bg-blue-50`,
        customDesignLogic
      )}
      {...props}
    >
      {children}
      <div className="flex-1 text-left">
        <div className={cn("text-sm font-medium text-gray-900", customTextDesignLogic)}>
          {label}
        </div>
      </div>
    </Button>
  );
};
